import { render, staticRenderFns } from "./PrescriptionTemp.vue?vue&type=template&id=4459d21e"
import script from "./PrescriptionTemp.vue?vue&type=script&lang=js"
export * from "./PrescriptionTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports